import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import VueCookies from 'vue-cookies';

library.add(faWandMagicSparkles);

createApp(App)
.use(VueCookies)
.use(router)
.component('font-awesome-icon', FontAwesomeIcon)
.mount('#app')